import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { ICopyResultData, ISetActivityCopyList } from '../../models/action/activityCopy';
import * as Actions from '../constants/activityCopy';
import storage from 'redux-persist/lib/storage';
import { IActivityCopyProps } from '../../models/components/activity-copy';
import { ICourseContentMenuSetAction } from '../../models/action/coursePage';

const _logger = Log.create('Activity-Copy Reducer');
const activityCopyReducer = (state = GlobalState().activityCopy, action: Types.IAction) => {
    if (!state) {
        return state;
    }

    const newState: any = { ...state };

    if (action.type === Actions.actions.SET_ACTIVITY_LIST) {
        const activityCopyAction = action as ISetActivityCopyList;
        newState.courseActivityList = activityCopyAction.courseActivityList;
    } else if (action.type === Actions.actions.SET_START_ACTIVITY_COPY) {
        const activityCopyAction = action as ICopyResultData;
        _logger.data('activityCopyAction', activityCopyAction);
        newState.copyResultData = activityCopyAction.copyResultData;
    }

    const persistCourseConfig = {
        key: 'activity-copy',
        storage
    };

    return Object.assign({}, state, newState);
};

export default activityCopyReducer;
